<template>
  <nuxt-link :to="{path}" class="button is-text" style="background-color: transparent; padding: 0;">
    <span class="icon"><i class="fas fa-angle-left"></i></span>
    <span>Kembali</span>
  </nuxt-link>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      default: ''
    }
  }
}
</script>
